export default __webpack_public_path__ + "522b83177d7acc4e827f25427fb9794d.png";